<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Alpha Wave</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Andrew Demcak</p>
<p class="P_Norm-NoIndent">The Elusive Spark: Book Two</p>
<p class="P_Normal"> </p>
<p class="P_Normal">With so many hunting her for the power she possesses, Keira Fairchild needs a friend in her corner.</p>
<p class="P_Normal">On the run from the Paragon Academy and a ring of slave traders, Keira is searching for answers. Who is the mysterious alien being trying to contact her in her dreams, and why is he being held captive? Keira learns she isn’t alone. James, Lumen, and Paul are teens with powers like her own—and all of them are in danger. They’ve been sent by their alien father to look for Keira. The kidnapped alien needs their help, and the unscrupulous Dr. Albion has a plan to rob them of their powers and destroy them. In the battle that awaits them, standing together is their only chance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?e6ac0e22